import React from 'react'
import slugify from '../../utils/slugify'
import Column from '../atoms/column'
import Label, { LabelProps } from '../atoms/label'
import Separator from '../atoms/separator'
import Textarea, { TextareaProps } from '../atoms/textarea'

export type TextareaInputProps = {
  label?: LabelProps['children']
  error?: string
} & Omit<TextareaProps, 'ref'>

function TextareaInput({
  label,
  id = slugify(label, { suffix: 'textarea-input' }),
  required,
  error,
  ...inputProps
}: TextareaInputProps) {
  return (
    <Column className="flex-1">
      {label && (
        <React.Fragment>
          <Label htmlFor={id} color={error ? 'danger-500' : undefined}>
            {label}
            {required ? ' *' : undefined}
          </Label>
          <Separator size="xs" />
        </React.Fragment>
      )}
      <Textarea id={id} error={error} {...inputProps} />
      <Column style={{ height: 0 }}>
        <Column className="min-h-1" />
        {error && (
          <span className="text-danger-500" style={{ fontSize: '0.65rem' }}>
            {error}
          </span>
        )}
      </Column>
    </Column>
  )
}

export default TextareaInput
